import { CallFlow } from "../features/call/CallFlow";
import { LanguageToggle } from "../i18n/LanguageToggle";
import { useI18n } from "../i18n/localization";
import { readCallEntry } from "../services/bootstrap";
import { BrandChip } from "./BrandTitle";

// Embedded shell — minimal chrome, the call surface only. The hosting police system
// opened GET /vc/v1/launch, which served the SPA bound to a callId and exposed the launch
// context as window.__VC_BOOTSTRAP__ (modules/04 §3). We render a compact case-context
// header so the officer sees which case they are about to hear, then the CallFlow.
export function EmbeddedShell() {
  const { t, dir } = useI18n();
  const ctx = readCallEntry(window, new URLSearchParams(window.location.search)).context;

  return (
    // Flex chain inlined (not only in styles.css): the app-service launch page loads the JS
    // bundle but NOT the extracted Vite CSS file. AppRoot owns the viewport column (shell
    // above the shared footer); this fills it so the call screen still fits the viewport.
    <div
      className="vc-shell vc-shell--embedded"
      style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}
    >
      {ctx && (
        <header
          dir={dir}
          style={{
            display: "flex", gap: 18, flexWrap: "wrap", alignItems: "center",
            background: "#eef3fb", color: "#1e2a3a", padding: "6px 14px",
            fontSize: 12, borderBottom: "1px solid #d6deea"
          }}
        >
          <BrandChip />
          <span><strong>{t.launch.system}:</strong> {ctx.systemCode}</span>
          <span><strong>{t.launch.driver}:</strong> {ctx.driverId}</span>
          <span><strong>{t.launch.caseRef}:</strong> {ctx.caseRefType}-{ctx.caseRef}</span>
          <span style={{ marginInlineStart: "auto" }}><LanguageToggle /></span>
        </header>
      )}
      {!ctx && (
        <div style={{ position: "absolute", top: 8, insetInlineEnd: 8, zIndex: 2 }}>
          <LanguageToggle />
        </div>
      )}
      {/* Fills the height left by the header; min-height:0 lets the call stage shrink to
          fit, and any taller non-call screen (e.g. the directory) scrolls inside here. */}
      <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "auto" }}>
        <CallFlow />
      </div>
    </div>
  );
}
